import { Component, OnInit, Input, Output, EventEmitter, ViewChild, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { AppUrls } from '../../../utility/appurls';
import { GenericLookupForm } from '../generic-lookup-form';
import { MaskUtility } from '../../../utility/mask-utility';
import { MaskConfig } from '../../../utility/mask-config';
import { SelectInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/select-input/select-input.component';
import { Observable } from 'rxjs';
import { FieldLabelConstants } from 'projects/bis-shared/src/lib/utility/field-label-constants';
import { DynamicFormsService } from '../../../dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { UserInputOptionType } from 'projects/bis-shared/src/lib/shared-models/user-input-option-type';
import { FormsModule } from '@angular/forms';
import { DynamicFormLoadDirective } from '../../../dynamic-forms/directives/dynamic-form-structural.directive';
import { TextInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/text-input/text-input.component';
import { GenericInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/generic-input/generic-input.component';


@Component({
  selector: 'app-third-party-administrator-lookup-form',
  templateUrl: './third-party-administrator-lookup-form.component.html',
  styleUrls: ['./third-party-administrator-lookup-form.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [FormsModule, DynamicFormLoadDirective , TextInputComponent, GenericInputComponent, SelectInputComponent],

 
})
export class ThirdPartyAdministratorLookupFormComponent
  extends GenericLookupForm
  implements OnInit {
  private dynamicFormsService = inject(DynamicFormsService);

  @ViewChild('thirdPartyAdministratorTypeList')
    thirdPartyAdministratorTypeList: SelectInputComponent;
  @Output() enterKey: EventEmitter<any> = new EventEmitter();
  @Input() events: Observable<void>;
  formLoaded = false;
  AppUrls = AppUrls;
  feinMaskConfig: MaskConfig;
  tpaNumberMaskConfig: MaskConfig;
  inIdMaskConfig = MaskUtility.getEntityIdMask('TP');
  FieldLabelConstants = FieldLabelConstants;

  
 

  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicFormsService
      .getFormGroupForModel('thirdPartyAdministratorLookup')
      .subscribe(formInfo => {
        this.formInfo = formInfo;
        this.form = formInfo.formGroup;
        this.formLoaded = true;
      });
  }

  search() {
    this.enterKey.emit();
  }

  onFeinChange() {
    this.feinMaskConfig = MaskUtility.getFEINMask();
  }

  onTpaNumberChange() {
    this.tpaNumberMaskConfig = MaskUtility.getTpaNumberMask();
  }

  public isValid(): boolean {
    return this.form && this.form.valid;
  }

  public reset(): void {
    this.form.reset({
      nameSearchOptionType: UserInputOptionType.Contains,
    });
    this.thirdPartyAdministratorTypeList.refreshOptions();
  }
}
